import { useEffect } from 'react'
import { loadMedications, saveMedications, todayKey } from '../lib/medications'

function ringBell() {
  try {
    const AudioCtx = window.AudioContext || (window as typeof window & { webkitAudioContext?: typeof AudioContext }).webkitAudioContext
    if (!AudioCtx) return
    const ctx = new AudioCtx()
    const gain = ctx.createGain()
    gain.gain.setValueAtTime(0.0001, ctx.currentTime)
    gain.gain.exponentialRampToValueAtTime(0.24, ctx.currentTime + 0.02)
    gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 1.15)
    gain.connect(ctx.destination)
    ;[880, 1174].forEach((frequency, index) => {
      const oscillator = ctx.createOscillator()
      oscillator.type = 'sine'
      oscillator.frequency.value = frequency
      oscillator.connect(gain)
      oscillator.start(ctx.currentTime + index * 0.12)
      oscillator.stop(ctx.currentTime + 1.2)
    })
    setTimeout(() => void ctx.close(), 1500)
  } catch {
    // Browser audio can be blocked until the user interacts with the page.
  }
}

function showNotification(name: string, dose?: string) {
  if (!('Notification' in window) || Notification.permission !== 'granted') return
  new Notification('Medication reminder', {
    body: `${name}${dose ? ` · ${dose}` : ''} is due now.`,
    tag: `schub-med-${name}`,
  })
}

export function MedicationReminderWatcher({ enabled }: { enabled: boolean }) {
  useEffect(() => {
    if (!enabled) return

    const check = () => {
      const now = new Date()
      const today = todayKey(now)
      const time = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`
      const items = loadMedications()
      let changed = false

      items.forEach(item => {
        if (!item.reminderEnabled || item.time !== time || item.takenDate === today || item.lastAlertDate === today) return
        item.lastAlertDate = today
        changed = true
        ringBell()
        showNotification(item.name, item.dose)
      })

      if (changed) saveMedications(items)
    }

    check()
    const id = window.setInterval(check, 15000)
    return () => window.clearInterval(id)
  }, [enabled])

  return null
}

